export default "__VITE_ASSET__VOiMDH3i__"